<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: "30%"
    },
    title: String,
    content: String,
    simple: Boolean,
    btnText: {
      type: String,
      default: "确定"
    },
    btnText2: String,
    showClose: {
      type: Boolean,
      default: true
    },
    Visible: Boolean,
  },
  methods: {
    close() {
      // console.log("close");
      this.$emit("close");
    },
    confirm() {
      // console.log("confirm");
      this.$emit("confirm");
    },
    confirm2() {
      // console.log("confirm");
      this.$emit("confirm2");
    },
  }
};
</script>

<template>
  <el-dialog
    custom-class="operationDialog"
    @close="close"
    :title="title"
    :show-close="showClose"
    :visible="Visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    :width="width"
  >
    <slot></slot>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm">{{btnText}}</el-button>
      <el-button v-if="btnText2" type="primary" @click="confirm2">{{btnText2}}</el-button>
    </span>
  </el-dialog>
</template>


<style lang="scss" >
.operationDialog {
  background-color: #fff;
  border-radius: 12px;
  .el-dialog__header {
    padding: 20px 10px;
    border-bottom: 1px solid #dfdfdf;
    .el-dialog__close {
      font-size: 25px;
    }
  }

  .el-dialog__body {
    // text-align: center;
    font-size: 16px;
    // padding: 10px;
  }
  .el-dialog__footer {
    padding: 0 10px 20px;
    text-align: center;
    .el-button--primary {
      min-width: 88px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/operationDialog.vue